import React, { Component } from "react";
import { Dialog } from "@fluentui/react-northstar";
import PageLoader from "../helpers/page-loader";
import IntlUtil from "../../../../core/helpers/intl-util";

class PageOverlay extends Component {
  _intl_ns_common = "common";

  render() {
    return (
      <Dialog
        backdrop={false}
        className="page-overlay"
        open={this.props.hidden}
        style={{
          background: "none",
        }}
        content={
          <PageLoader
            status={this.props.loading}
            size="medium"
            labelPosition="below"
            label={IntlUtil.getText(
              this._intl_ns_common,
              "content.loadingInprogress"
            )}
            type="full-center"
          >
            <></>
          </PageLoader>
        }
      />
    );
  }
}
export default PageOverlay;
